<template>
  <div class="passing-train-list">
    <el-row class="train-handler">
      <el-col :span="9">
        <span class="passing-module-title">车节列表</span>
        <!--        <el-button v-has-permi="[`${permiStr}:carriage:add`]" type="primary" @click="handleAdd">录入</el-button>-->
      </el-col>
      <el-col :span="6" class="padding-rt-10">
        <el-input v-model="filterParams.trainNo" placeholder="车号" clearable @change="handleFilter"></el-input>
      </el-col>
      <el-col :span="6" class="padding-rt-10">
        <matrix-select v-model="filterParams.errType" :custom-options="testOptions" :clearable="false" need-all
                       @onSelect="handleFilter"></matrix-select>
      </el-col>
      <el-col :span="1">
        <el-button @click="handleReset(true)">重置</el-button>
      </el-col>
    </el-row>
    <avue-crud
      ref="crud"
      :option="option"
      :data="data"
      :table-loading="loading"
      :row-class-name="listRowClassName"
      @row-dblclick="handleListDBClick"
    >
      <template #customMenu="{row}">
        <i v-if="Number(row.isAiAdd) !== 1" class="el-icon-delete table-del-btn--disabled"></i>
        <i v-else class="el-icon-delete table-del-btn" @click="handleListDel(row)"></i>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import MatrixSelect from "@/components/matrix/matrix-select.vue";
import {carriageDelete} from "@/api/handover-inspection/passing-manage";

export default {
  name: "passing-train-list",
  components: {MatrixSelect},
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => []
    },
    baseData: Array, // 记录初始数据
    carriageIdx: Number, // 选中下标
    permiStr: String,
  },
  data() {
    return {
      testOptions: [
        {dictKey: '0', dictValue: '否'},
        {dictKey: '1', dictValue: '是'},
      ],
      filterParams: {
        trainNo: '',
        errType: ''
      },
      option: {
        border: true,
        header: false,
        menu: false,
        align: 'center',
        selection: false,
        index: false,
        column: [
          {
            label: "车厢序号",
            prop: "trainSerial",
            width: 103,
          },
          {
            label: "车型",
            prop: "trainType",
            minWidth: 75,
          },
          {
            label: "车号",
            prop: "trainNo",
            minWidth: 80,
          },
          // {
          //   label: "异常",
          //   prop: "err",
          //   width: 50,
          //   formatter: (row) => row.isError ? '是' : '否'
          // },
          {
            label: "操作",
            prop: "customMenu",
            width: 65
          }
        ]
      }
    }
  },
  created() {
    // 列表高度
    const pageH = document.documentElement.clientHeight;
    this.option.height = ~~((pageH - 60) * 0.5 - 60).toString()
  },
  methods: {
    // 筛选
    handleFilter() {
      const {trainNo, errType} = this.filterParams
      this.$emit('update:data', [])
      const isError = errType === '1'
      const arr = this.baseData.filter(item => {
        return (!trainNo || item.trainNo.includes(trainNo)) && (!errType || isError === item.isError)
      })
      setTimeout(() => {
        this.$emit('update:data', arr)
        if (arr.length) {
          // 筛选后选中第 0 个
          // this.$emit('handle-select', 0)
        }
      }, 100)
    },
    // 重置筛选
    handleReset(refresh) {
      this.filterParams = {
        trainNo: '',
        errType: ''
      }
      if (refresh) this.handleFilter()
    },
    listRowClassName({row, rowIndex}) {
      row.idx = rowIndex
      const {trainNo, outMonth, inspectTime, isError} = row
      // 车号不为空 && 车号不等于 7（红色）
      const isErr = !trainNo || isError
      // 定检期超期 || 定检识别错误（橙色）
      const isWarning = outMonth > 0 || (inspectTime && inspectTime.indexOf("*") !== -1)
      // 文字颜色
      const color = isErr ? 'error-row' : isWarning ? 'warning-row' : ''
      // 背景颜色
      let bgColor = ''
      // if (rowIndex === this.carriageIdx) {
      //   const warning = isErr ? '--warning' : ''
      //   bgColor = `row-selected${warning}`
      //   this.$nextTick(() => {
      //     // 视图自动滚动到选中行
      //     const element = this.$refs.crud.$el.querySelector('.' + bgColor)
      //     if (element) element.scrollIntoView({block: 'center'});
      //   })
      // }
      if (isErr) {
        bgColor = 'row-selected--warning'
        this.$nextTick(() => {
          // 视图自动滚动到选中行
          const element = this.$refs.crud.$el.querySelector('.' + bgColor)
          if (element) element.scrollIntoView({block: 'center'});
        })
      }
      return [bgColor, 'triangle-box']
    },
    // 切换车厢
    handleListDBClick(row) {
      this.$emit('handle-select', row.$index)
    },
    // 录入车厢
    handleAdd() {
      this.$emit('handleAdd')
    },
    handleListDel(row) {
      this.$modal.confirm('确定删除选中信息？').then(() => {
        this.$emit('update:loading', true)
        carriageDelete({trainDetailId: row.id}).then(res => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.$emit('handleDel')
          } else {
            this.$emit('update:loading', false)
          }
        }).catch(() => {
          this.$emit('update:loading', false)
        })
      })
    },
    // 添加小三角
    handleDomChange(idx) {
      const oldTriangle = document.getElementsByClassName('triangle_carriageList')
      if (oldTriangle.length) oldTriangle[0].remove()
      const arr = this.$refs.crud.$el.querySelectorAll('.el-table__row')
      const triangle = document.createRange().createContextualFragment(`<div class="triangle_carriageList"></div>`)
      arr[idx].append(triangle);
      this.$forceUpdate()
    },
  },
  watch: {
    data(list) {
      if (!list.length) return this.errorList = []
      this.$nextTick(() => {
        this.handleDomChange(this.carriageIdx)
      })
    },
    carriageIdx(idx) {
      this.handleDomChange(idx)
    }
  }
}
</script>

<style scoped lang="scss">
.train-handler {
  margin-bottom: 10px;

  .el-button--mini {
    padding: 7px 9px;
  }

  .el-button--primary {
    padding: 7px 12px;
  }

  .padding-rt-10 {
    padding-right: 3px;
  }
}

::v-deep .el-table .el-table__header-wrapper th {
  font-size: 20px;
}

.passing-train-list {
  height: 50%;

  ::v-deep .el-table--mini {
    font-size: 20px !important;

    .el-table__cell {
      height: 45px;
    }
  }
}

::v-deep .triangle-box {
  position: relative;
}

::v-deep .triangle_carriageList {
  position: absolute;
  left: -3%;
  top: 5%;
  width: 0;
  height: 0;
  border-top: 22px solid transparent;
  border-left: 25px solid #2292d6;
  border-bottom: 22px solid transparent;
  z-index: 2002;
}
</style>
